<template>
  <div class="login-body bg-F3F4F9">
    <div class="auth-navigationbar bg-282B80 cursor"  @click="toHome">
      <!-- <img src="../../../../assets/icon-lib-logo-bg.png" class="cursor" @click="toHome"> -->
      <!-- <img src="@/assets/image@2x.png" class="cursor" @click="toHome"> -->
      <img :src="clients.logoMain" alt="">
    </div>
    <div class="auth-body flex-column-align-center">
      <div class="auth-body-view bg-white">
        <div class="auth-body-view-menu flex-center">
          <div class="cursor" @click="changeLoginType(0)">
            <p class="font-size-20 font-color-264480" :class="[menuSelindex==0?'font-bold':'',menuSelindex==1?'opacity':'']">个人登录</p>
          </div>
          <div class="auth-body-view-menu-line" />
          <div class="cursor" @click="changeLoginType(1)">
            <p class="font-size-20 font-color-264480" :class="[menuSelindex==1?'font-bold':'',menuSelindex==0?'opacity':'']">团体登录</p>
          </div>
        </div>

        <!-- 个人登录 -->
        <div v-if="menuSelindex==0">
          <!-- 手机号短信验证码表单 -->
          <div class="auth-body-view-menu-form">
            <div class="auth-body-view-menu-form-item" :class="personphoneerror?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-login-phone.png" alt="">
                <el-input v-model="personphone" placeholder="请输入您的手机号" size="normal" :maxlength="11" @blur="inputPhone" />
              </div>
            </div>

            <!-- 输入手机号规则校验错误提示 -->
            <div v-if="personphoneerror" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入正确手机号</p>
              </div>
            </div>

            <div class="auth-body-view-menu-form-item" :class="personcodeerror?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-login-phonecode.png" alt="">
                <el-input v-model="personcode" placeholder="请输入短信验证码" size="normal" :maxlength="6" @blur="inputCode" />
                <div class="auth-body-view-menu-form-item-option-codebtn flex-center bg-282B80 cursor" :class="personcodebtntext!='获取短信验证码'&&personcodebtntext!='重新获取验证码'?'auth-body-view-menu-form-item-option-codebtnopacity':''" @click="verifyapply">
                  <p class="font-color-white font-size-12">{{ personcodebtntext }}</p>
                </div>
              </div>
            </div>

            <!-- 输入验证码规则校验错误提示 -->
            <div v-if="personcodeerror" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入验证码</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 团体登录 -->
        <div v-else>
          <!-- 手机号短信验证码表单 -->
          <div class="auth-body-view-menu-form">
            <div class="auth-body-view-menu-form-item" :class="groupphoneerror?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-login-phone.png" alt="">
                <el-input v-model="groupphone" placeholder="请输入您的手机号" size="normal" :maxlength="11" @blur="inputTeamPhone" />
              </div>
            </div>

            <!-- 输入手机号规则校验错误提示 -->
            <div v-if="groupphoneerror" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入正确手机号</p>
              </div>
            </div>

            <div class="auth-body-view-menu-form-item" :class="groupcodeError?'auth-body-view-menu-form-item-inputerror':''">
              <div class="flex flex-row-align-center auth-body-view-menu-form-item-option">
                <img src="../../../../assets/icon-lib-login-phonecode.png" alt="">
                <el-input v-model="groupcode" placeholder="请输入短信验证码" size="normal" :maxlength="6" @blur="inputTeamCode" />
                <div class="auth-body-view-menu-form-item-option-codebtn flex-center bg-282B80 cursor" :class="groupcodebtntext!='获取短信验证码'&&groupcodebtntext!='重新获取验证码'?'auth-body-view-menu-form-item-option-codebtnopacity':''" @click="verifyapply">
                  <p class="font-color-white font-size-12">{{ groupcodebtntext }}</p>
                </div>
              </div>
            </div>

            <!-- 输入验证码规则校验错误提示 -->
            <div v-if="groupcodeError" class="auth-body-view-menu-form-ruleerror">
              <div class="flex-row-align-center ">
                <p class="font-size-12 font-color-CD2E2E">请输入验证码</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 登录按钮 -->
        <div class="auth-body-view-login">
          <div class="auth-body-view-login-btn bg-282B80 flex-center cursor" @click="requestLogin">
            <p class="font-color-white font-size-14 font-bold">登录</p>
          </div>
        </div>

        <!-- 第三方登录 -->
        <div v-if="menuSelindex==0" class="auth-body-view-wechat">
          <div class="auth-body-view-wechat-btn flex-row-align-center cursor" @click="toWechat">
            <p class="font-size-12 font-color-666">使用第三方登录</p>
            <img src="../../../../assets/icon-lib-login-wechat.png" alt="">
          </div>
        </div>

        <!-- 说明 -->
        <div v-if="menuSelindex==0" class="auth-body-view-protocal">
          <div class="auth-body-view-protocal-text flex-center">
            <p class="font-color-B29453 font-size-12">未注册手机验证后自动登录，注册即代表同意</p>
            <p class="font-color-B29453 font-size-12 font-underline cursor" @click="toPotocal">《服务使用协议》</p>
            <p class="font-color-B29453 font-size-12 font-underline cursor" @click="toSecret">《个人信息保护政策》</p>
          </div>
        </div>

        <div v-if="menuSelindex==1" class="auth-body-view-space" />
      </div>
    </div>
    <verify ref="verify" :mode="'pop'" :captcha-type="'blockPuzzle'" :img-size="{ width: '330px', height: '155px' }" @success="verifySuccess" />
  </div>
</template>

<script>
import api from '../../../../api/auth.js'
import auth from '../../../..//models/auth.js'
import user from '../../../..//models/user.js'
import config from '../../../..//utils/config.js'
// import { replaceUrl } from '../../../../utils/utils.js'
import verify from '@/components/verifition/Verify.vue'
const Base64 = require('js-base64').Base64

export default {
  name: 'Login',
  components: {
    verify
  },
  data() {
    return {
      menuSelindex: 0,

      redirectUrl: '',

      personphone: '',
      personcode: '',
      persontimer: null,
      persontimeremain: 60,
      personcodebtntext: '获取短信验证码',
      personphoneerror: false,
      personcodeerror: false,

      groupphone: '',
      groupcode: '',
      grouptimer: null,
      grouptimeremain: 60,
      groupcodebtntext: '获取短信验证码',
      groupphoneerror: false,
      groupcodeError: false,

      wxcode: null,
      skip: null,
      showError: false,
      clients: ''
    }
  },
  created() {
    this.skip = this.$route.query.skip || 'y'
    this.wxcode = this.$route.query.code || 0
    this.redirectUrl = this.$route.query.r || '/'
    const tid = this.$route.query.tid || 'ADKS'
    if (tid === 'ADKS') {
      if (this.wxcode) {
        this.requestLoginByWxcode()
      }
    } else if (tid === 'CQU') {
      const auth_url = `https://cqu.cnmrms.com/#/login?code=${this.wxcode}&r=${this.redirectUrl}`
      window.location.replace(auth_url)
    } else if (tid === 'SWJTU') {
      const auth_url = `https://swjtu.cnmrms.com/#/login?code=${this.wxcode}&r=${this.redirectUrl}`
      window.location.replace(auth_url)
    }else if (tid === 'CNU') {
      const auth_url = `https://cnu.cnmrms.com/#/login?code=${this.wxcode}&r=${this.redirectUrl}`
      window.location.replace(auth_url)
    }else if (tid === 'YGYD') {
      const auth_url = `https://ygyd.cnmrms.com/#/login?code=${this.wxcode}&r=${this.redirectUrl}`
      window.location.replace(auth_url)
    }

    let that = this;
    this.$store.dispatch('navigation/setNavigatorIndex', 0)
    setTimeout(() => {
      that.clients = that.$store.getters.application  
    }, 1200);
  },
  methods: {
    toHome() {
      this.$store.dispatch('navigation/setNavigatorIndex', 0)
      this.$router.push({
        path: '/'
      })
    },
    changeLoginType(t) {
      this.menuSelindex = t
    },
    getPhoneCode(code) {
      if (this.menuSelindex === 0) {
        if (this.personcodebtntext !== '获取短信验证码' && this.personcodebtntext !== '重新获取验证码') {
          return
        }
        if (!(/^1[3456789]\d{9}$/.test(this.personphone))) {
          console.error(`填写正确的手机号${this.personphone}`)
          return
        }

        const params = {
          phone: this.personphone,
          captchaVerification: code,
          clientUid: localStorage.getItem('slider')
        }
        console.log(params)
        const that = this
        api.sliderCheck(params).then(r => {
          console.log(r)
          that.timeRemain()
        }).catch(err => {
          console.error(err)
        })
      } else {
        if (this.groupcodebtntext !== '获取短信验证码' && this.groupcodebtntext !== '重新获取验证码') {
          return
        }
        if (!(/^1[3456789]\d{9}$/.test(this.groupphone))) {
          console.error(`填写正确的手机号${this.groupphone}`)
          return
        }

        const params = {
          phone: this.groupphone,
          captchaVerification: code,
          clientUid: localStorage.getItem('slider')
        }
        console.log(params)
        const that = this
        api.sliderCheck(params).then(r => {
          console.log(r)
          that.timeRemain()
        }).catch(err => {
          console.error(err)
        })
      }
    },
    timeRemain() {
      if (this.menuSelindex === 0) {
        if (!this.persontimer) {
          const that = this
          const timer = setInterval(() => {
            that.persontimeremain = that.persontimeremain - 1
            if (that.persontimeremain === 0) {
              that.persontimeremain = 60
              clearInterval(timer)
              that.persontimer = null
              that.personcodebtntext = '重新获取验证码'
              that.personcode = ''
            } else {
              that.personcodebtntext = `${that.persontimeremain}s后重新获取`
            }
          }, 1000)
          this.persontimer = timer
        }
      } else {
        if (!this.grouptimer) {
          const that = this
          const timer = setInterval(() => {
            that.grouptimeremain = that.grouptimeremain - 1
            if (that.grouptimeremain === 0) {
              clearInterval(timer)
              that.grouptimeremain = 60
              that.grouptimer = null
              that.groupcodebtntext = '重新获取验证码'
              that.groupcode = ''
            } else {
              that.groupcodebtntext = `${that.grouptimeremain}s后重新获取`
            }
          }, 1000)
          this.grouptimer = timer
        }
      }
    },
    inputPhone() {
      this.personphoneerror = !(/^1[3456789]\d{9}$/.test(this.personphone))
    },
    inputCode() {
      if (!this.personcode || this.personcode === '') {
        this.personcodeerror = true
      } else {
        this.personcodeerror = false
      }
    },
    inputTeamPhone() {
      this.groupphoneerror = !(/^1[3456789]\d{9}$/.test(this.groupphone))
    },
    inputTeamCode() {
      if (!this.groupcode || this.groupcode === '') {
        this.groupcodeError = true
      } else {
        this.groupcodeError = false
      }
    },
    verifyapply() {
      if (this.menuSelindex === 0) {
        if (this.personphoneerror || this.personphone === '') {
          return
        }
        if (this.personcodebtntext === '获取短信验证码' || this.personcodebtntext === '重新获取验证码') {
          this.$refs.verify.show()
        }
      } else {
        if (this.groupphoneerror || this.groupphone === '') {
          return
        }
        if (this.groupcodebtntext === '获取短信验证码' || this.groupcodebtntext === '重新获取验证码') {
          this.$refs.verify.show()
        }
      }
    },
    verifySuccess(params) {
      this.getPhoneCode(params.captchaVerification)
    },
    toWechat() {
      const jsonstr = JSON.stringify({ 'u': 'login', 'r': this.redirectUrl, 'tid': 'ADKS' })
      const auth_url = `https://open.weixin.qq.com/connect/qrconnect?appid=wx2d0f0d039e76cf15&scope=snsapi_login&state=${Base64.encode(jsonstr)}&redirect_uri=${config.profile.pcHost}/#/`
      window.location.replace(auth_url)
    },
    requestLogin() {
      if (this.showError) {
        return
      }
      var params = {}
      if (this.menuSelindex === 0) {
        if (!this.personphone || this.personphone === '' || !(/^1[3456789]\d{9}$/.test(this.personphone))) {
          this.$message({
            showClose: false,
            message: '请输入正确手机号',
            type: 'error'
          })
          return
        }
        if (!this.personcode || this.personcode === '') {
          this.$message({
            showClose: false,
            message: '请输入验证码',
            type: 'error'
          })
          return
        }
        params = {
          code: this.personcode,
          phone: this.personphone,
          userType: 1,
          tenantId:this.$store.getters.tenantId
        }
      } else {
        if (!this.groupphone || this.groupphone === '' || !(/^1[3456789]\d{9}$/.test(this.groupphone))) {
          this.$message({
            showClose: false,
            message: '请输入正确手机号',
            type: 'error'
          })
          return
        }
        if (!this.groupcode || this.groupcode === '') {
          this.$message({
            showClose: false,
            message: '请输入验证码',
            type: 'error'
          })
          return
        }
        params = {
          code: this.groupcode,
          phone: this.groupphone,
          userType: 2,
          tenantId: this.$store.getters.tenantId
        }
      }
      const that = this
      api.loginWithPhoneCode(params).then(r => {
        that.$store.dispatch('user/setToken', r.data.authInfo)
        user.save(r.data.userInfo)
        if (params.userType === 2) {
          that.$router.push({
            path: that.redirectUrl
          })
        } else {
          if (parseInt(r.data.userInfo.authentication)) {
            that.$router.push({
              name: 'Home'
              // path: that.redirectUrl
            })
          } else {
            that.$router.push({
              name: 'Auth',
              query: {
                r: that.redirectUrl,
                skip: that.skip
              }
            })
          }
        }
      }).catch(err => {
        that.showError = true
        that.errorCounter()
        that.$message({
          showClose: false,
          message: err.message,
          type: 'error'
        })
      })
    },
    requestLoginByWxcode() {
      if (this.showError) {
        return
      }
      const params = {
        code: this.wxcode,
        tenantId: this.$store.getters.tenantId
      }
      const that = this
      api.loginwithwechat(params).then(r => {
        const data = r.data
        if (data.isAccount === 'false') {
          // 跳转绑定手机号页面
          that.$router.push({
            path: '/bind',
            query: {
              r: that.redirectUrl,
              open: data.openid,
              access: data.access_token
            }
          })
        } else {
          that.$store.dispatch('user/setToken', r.data.authInfo)
          auth.save(data.authInfo)
          if (parseInt(r.data.userInfo.authentication)) {
            that.$router.push({
              path: that.redirectUrl
            })
          } else {
            that.$router.replace({
              path: '/auth',
              query: {
                r: that.redirectUrl,
                skip: that.skip
              }
            })
          }
        }
      }).catch(error => {
        that.showError = true
        that.errorCounter()
        that.$message({
          showClose: false,
          message: error.message,
          type: 'error'
        })
      })
    },
    toPotocal() {
      const routeData = this.$router.resolve({
        name: 'Profile',
        query: {
          t: 'potocal'
        }
      })
      window.open(routeData.href, '_blank')
    },
    toSecret() {
      const routeData = this.$router.resolve({
        name: 'Profile',
        query: {
          t: 'secret'
        }
      })
      window.open(routeData.href, '_blank')
    },
    toHome() {
      this.$store.dispatch('navigation/setNavigatorIndex', 0)
      this.$router.push({
        path: '/'
      })
    },
    errorCounter() {
      const that = this
      setTimeout(() => {
        that.showError = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
  color: #264480 !important;
  padding: 0 !important;
  border: none !important;
  background: initial;
}

::v-deep .el-input__suffix-inner {
  display: none;
}

::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-input__prefix {
  left: 0;
  display: none;
}

::v-deep .el-input__icon {
  width: initial !important;
}

::v-deep .el-input {
  width: initial;
  flex: 1;
}

/deep/ .el-select-dropdown__item.selected {
  color: #264480 !important;
}
</style>

<style src="@/styles/pc.css" scoped>
</style><style scoped>

.login-body {
  flex: 1;
}
.auth-navigationbar img{
  width: auto;
  height: 100%;
}
.auth-navigationbar {
  width: 100%;
  height: 70px;
}

.auth-body {
  width: 1240px;
  height: 510px;
  margin: 0 auto;
  background-color: #F3F4F9;
  padding-top: 50px;
}

.auth-body-view {
  width: 600px;
  padding-top: 30px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05);
}

.auth-body-view-menu {
  height: 54px;
  width: 100%;
}

.auth-body-view-menu-line {
  width: 1px;
  height: 20px;
  background-color: #F3F4F9;
  margin: 0 26px;
}

.opacity {
  opacity: 0.7;
}

.auth-body-view-menu-form {
  margin-top: 20px;
}

.auth-body-view-menu-form-item {
  height: 40px;
  padding: 0 130px;
  margin-bottom: 24px;
}

.auth-body-view-menu-form-item-inputerror {
  margin-bottom: 0;
}

.auth-body-view-menu-form-item input {
  border: none;
  width: 100%;
  height: 40px;
  background-color: rgba(0, 0, 0, 0);
}

.auth-body-view-menu-form-item input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #7B84A1;
}

.auth-body-view-menu-form-item input:focus {
  outline: none;
}

.auth-body-view-menu-form-item-option {
  border: 1px solid #DEE0E7;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  background: #F9F9FC;
}

.auth-body-view-menu-form-ruleerror {
  height: 40px;
  width: 100%;
  padding: 0 130px;
  margin-bottom: 8px;
}

.auth-body-view-menu-form-ruleerror>div {
  height: 40px;
}

.auth-body-view-menu-form-item-inputerror .auth-body-view-menu-form-item-option {
  border: 1px solid #CD2E2E;
  height: 40px;
  width: 100%;
  padding: 0 8px;
  background: #FFEFEF;
}

.auth-body-view-menu-form-item-option-codebtn {
  width: 100px;
  height: 24px;
}

.auth-body-view-menu-form-item-option-codebtnopacity {
  opacity: 0.5;
}

.auth-body-view-login {
  padding: 22px 130px 0;
}

.auth-body-view-login-btn {
  height: 40px;
}

.auth-body-view-wechat {
  padding: 10px 130px 0;
}

.auth-body-view-wechat-btn {
  height: 40px;
}

.auth-body-view-login-btn {
  height: 40px;
}

.auth-body-view-protocal {
  padding: 26px 0 0;
}

.auth-body-view-protocal-text {
  background: #FFFAEF;
  height: 40px;
}

.auth-body-view-space {
  height: 60px;
}
</style>
